"use client";
import React from "react";
import Marquee from "react-fast-marquee";
import "./style.css";

export const FeatureSlider = () => {
  const sliderItems = [
    {
      id: 1,
      title: "AI TOY",
      image:
        "https://c.animaapp.com/mc7mid1iBigxuJ/img/freepik--the-style-is-candid-image-photography-with-natural--633.png",
    },
    {
      id: 2,
      title: "KIDS GAMES",
      image:
        "https://c.animaapp.com/mc7mid1iBigxuJ/img/freepik--the-style-is-candid-image-photography-with-natural--633-1.png",
    },
    {
      id: 3,
      title: "ENTERTAINMENT",
      image:
        "https://c.animaapp.com/mc7mid1iBigxuJ/img/freepik--the-style-is-candid-image-photography-with-natural--633-2.png",
    },
    {
      id: 4,
      title: "MARKETPLACE",
      image:
        "https://c.animaapp.com/mc7mid1iBigxuJ/img/freepik--the-style-is-candid-image-photography-with-natural--633-3.png",
    },
    {
      id: 5,
      title: "ARTIFICIAL INTELLIGENCE",
      image:
        "https://c.animaapp.com/mc7mid1iBigxuJ/img/freepik--the-style-is-candid-image-photography-with-natural--633-4.png",
    },
    {
      id: 6,
      title: "JOIN PRESALE",
      image:
        "https://c.animaapp.com/mc7mid1iBigxuJ/img/freepik--the-style-is-candid-image-photography-with-natural--633-5.png",
    },
    {
      id: 7,
      title: "PC GAME",
      image:
        "https://c.animaapp.com/mc7mid1iBigxuJ/img/freepik--the-style-is-candid-image-photography-with-natural--633-6.png",
    },
  ];

  const gradientText = "gradient-text-glow";

  return (
    <div className="py-8 border-y-[4px] border-black bg-[#111] w-full overflow-hidden">
      <Marquee gradient={false} speed={50} pauseOnHover={true}>
        {[...sliderItems, ...sliderItems].map((item, index) => (
          <div
            key={index}
            className="flex items-center gap-4 mx-8 min-w-[200px]"
          >
            <img
              src={item.image}
              alt={item.title}
              className="w-[60px] h-[80px] object-contain"
            />
            <div className={`div-wrappers`}>
              <div className={`${gradientText}`}>{item.title}</div>
            </div>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
